module.exports = __webpack_public_path__ + "static/media/Lithuania.81617ced.png";